import { graphql } from 'gatsby';
import { exists, getKey, isValidArray } from '../../../helpers';

/**
 * Promotions widget definition
 * @param {Object} props of the widget
 * @param {string} locale of the widget
 * @returns {Object} widget definition
 */
export const featuredblog = function featuredblog(props, locale) {
  let items = getKey(props, 'items');
  if (!items) {
    items = getKey(props, 'featuredpages');
  }

  return {
    locale,
    items:
      isValidArray(items)
      && items.map((item) => {
        return {
          key: getKey(item, 'id'),
          title: getKey(item, `title_${locale}`),
          slug: getKey(item, `url_${locale}`),
          image: getKey(item, 'thumbnail.url')
        };
      }),
  };
};

export default function featuredblogprovider(props, locale) {
  const key = getKey(props, 'key');

  return {
    locale,
    featureblogId: key
  };
}

/**
 * GraphQL query
 */
export const query = graphql`
  fragment Featuredblogs on StrapiWidgetrels {
    featuredblog {
      widgetPosition
      key: id
      items: featuredpages {
            key: id
            title_en
            title_es
            url_en
            url_es
            thumbnail {
              childImageSharp {
                fluid(maxWidth: 960, quality: 80) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
      }
    }
  }
`;
